const config = {
  "url-prefix": (!process.env.NODE_ENV || process.env.NODE_ENV === "development") ?
    "https://axkd4ibg7lpu.objectstorage.eu-stockholm-1.oci.customer-oci.com/n/axkd4ibg7lpu/b/tinsv-dev-bucket/o/" :
    "https://axkd4ibg7lpu.objectstorage.eu-stockholm-1.oci.customer-oci.com/n/axkd4ibg7lpu/b/tinsv-bucket/o/",
  "title-prefix": "tinsv.com - ",
}

export default config
